import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { wrapIdForPic } from '@framework/workbench/util/wrap-id-util';
import { TOOLBAR_ROTATE_ICON } from '@editor/src/img/pageIndex';

export const config = {
    id: ActionType.ROTATE,
    tipMsg: i18n.t('旋转'),
    content: i18n.t('旋转'),
    icon: TOOLBAR_ROTATE_ICON,
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        hasArrow: true,
        text: config.content,
        tooltip: config.tipMsg,
        icon: <img src={config.icon} alt={''}/>,
        style: {
            width: 'auto',
        },
    },
];

export const ROTATE_RIGHT_90_CONFIG: MenuConfig = {
    name: ActionType.ROTATE_RIGHT_90,
    content: i18n.t<string>('向右旋转90°'),
};

export const ROTATE_LEFT_90_CONFIG: MenuConfig = {
    name: ActionType.ROTATE_LEFT_90,
    content: i18n.t<string>('向左旋转90°'),
};

export const FLIP_VERTICAL_CONFIG: MenuConfig = {
    name: ActionType.FLIP_VERTICAL,
    content: i18n.t<string>('垂直翻转'),
};

export const FLIP_HORIZONTAL_CONFIG: MenuConfig = {
    name: ActionType.FLIP_HORIZONTAL,
    content: i18n.t<string>('水平翻转'),
};

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
    },
    ROTATE_RIGHT_90_CONFIG,
    ROTATE_LEFT_90_CONFIG,
    FLIP_VERTICAL_CONFIG,
    FLIP_HORIZONTAL_CONFIG,
];
